import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/pro-solid-svg-icons";
import { formatSwissPrice } from "../../../../utils/formatting";

const PostAIWizardItem = ({
  dish,
  isActive,
  isReviewed,
  isDeleted,
  onClick,
}) => {
  const isActivated = !!dish.isActive;
  const stateClass = isDeleted
    ? "wizard-item--deleted"
    : isActive
      ? "wizard-item--active"
      : isReviewed || isActivated
        ? "wizard-item--reviewed"
        : "";

  const icon = isDeleted
    ? faCircleXmark
    : isReviewed || isActivated
      ? faCircleCheck
      : faCircle;

  return (
    <div
      className={`wizard-item ${stateClass}`}
      onClick={isDeleted ? undefined : onClick}
    >
      <span className="wizard-item__status">
        <FontAwesomeIcon icon={icon} size="xs" />
      </span>
      <span className="wizard-item__name" title={dish.name}>
        {dish.name || "—"}
      </span>
      {dish.price != null && (
        <span className="wizard-item__price">
          {formatSwissPrice(dish.price, true)}
        </span>
      )}
    </div>
  );
};

export default PostAIWizardItem;
